export default "__VITE_ASSET__BuyABXtf__"